import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import LanguageStrings from '../../../i18n/locales'
const AddDeviceComponent = LanguageStrings().DeviceManagementCollectionStrings.AddDeviceComponent

// Define schemas using Zod
const ZEmailGroup = z.object({
  groupName: z.string(),
  groupId: z.string(),
  enabled: z.boolean()
})

const ZEmailGroupContent = z.object({
  totalCount: z.number(),
  content: z.array(ZEmailGroup)
})

const ZEmailGroupsResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: ZEmailGroupContent
})

// Export types derived from Zod schemas
export type EmailGroup = z.infer<typeof ZEmailGroup>
export interface EmailGroupsResponse {
  data: EmailGroup[]
  totalCount: number
}

export async function getEmailGroups (
  page: number,
  pageSize: number,
  sortEnabled: boolean,
  onSuccess: (emailGroups: EmailGroupsResponse, httpStatus: number) => void,
  onFailure: (errorMessage: any, httpStatus: number) => void
): Promise<void> {
  // Constructing query parameters
  const params = new URLSearchParams({
    page: (page + 1).toString(),
    pageSize: pageSize.toString(),
    sortEnabled: sortEnabled.toString()
  })
  const url = `/communications-service/api/v1/udp/tiq/services/email/groups?${params.toString()}`
  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZEmailGroupsResponse.safeParse(response.data)
      if (parseResponse.success) {
        if (parseResponse.data.data !== null && parseResponse.data.data !== undefined) {
          onSuccess({
            data: parseResponse.data.data.content,
            totalCount: parseResponse.data.data.totalCount
          }, parseResponse.data.http_status)
        } else {
          onFailure(parseResponse.data.error, parseResponse.data.http_status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure(AddDeviceComponent.NetworkError, error.status)
      }
    })
}
